import { associatedKeyMessage } from '../../../services/deploy-action-messages';
import { Deploy } from '@block-explorer/entities';
import { FlexColumn, FlexRow } from '@make-software/cspr-ui';
import { BodyText, Tooltip } from '@block-explorer/ui';
import { SHORTENED_ENTRY_TYPE_LENGTH, truncateName } from '../utils';
import React from 'react';
import styled from 'styled-components';
import { AccountInfoIcon } from '../../account-info-icon/account-info-icon';
import { buildRouterPath } from '../../../router/utils';
import { ACCOUNT_DETAILS_PATH } from '../../../router/paths';
import { DefaultActionMessage } from './default-action-message';
import { ContractIdentifier } from '../../contract-identifier/contract-identifier';

const EntryTypeRow = styled(FlexRow)(({ theme }) => ({
  maxWidth: '25rem',
}));

export const AssociatedKeysActionMessage = ({
  deploy,
  isHome,
}: {
  deploy: Deploy;
  isHome?: boolean;
}) => {
  const message = isHome
    ? associatedKeyMessage().prepareActionMessageDataForHome(deploy)
    : associatedKeyMessage().prepareActionMessageData(deploy);

  if (!message) {
    return <DefaultActionMessage deploy={deploy} isHome={isHome} />;
  }

  return (
    <FlexColumn>
      <EntryTypeRow align={'baseline'} itemsSpacing={4}>
        <Tooltip title={message.entryPointName}>
          <BodyText monotype size={3} wordBreak noWrap>
            {truncateName(message.actionName, SHORTENED_ENTRY_TYPE_LENGTH)}
          </BodyText>
        </Tooltip>
        {message.callerAccount && message.callerAccount.publicKey && (
          <BodyText size={3} variation={'darkGray'}>
            <FlexRow itemsSpacing={6} align={'center'}>
              <>
                {message.callerPrefix && <span>{message.callerPrefix}</span>}
                <AccountInfoIcon
                  publicKey={message.callerAccount.publicKey}
                  logo={null}
                  path={buildRouterPath(
                    ACCOUNT_DETAILS_PATH,
                    { id: message.callerAccount?.publicKey },
                    undefined
                  )}
                />
              </>
            </FlexRow>
          </BodyText>
        )}
      </EntryTypeRow>
      <FlexRow itemsSpacing={4}>
        <BodyText variation={'darkGray'} size={3}>
          with
        </BodyText>
        <ContractIdentifier
          hash={deploy.contractPackage.contract_package_hash}
          contractPackage={deploy.contractPackage}
        />
      </FlexRow>
    </FlexColumn>
  );
};
